<template>
    <GuestStudentLayout>
        <div class="w-100">
            <div class="row justify-content-center">
                <div class="col-10 col-sm-7 col-md-5 col-lg-8 col-xl-7 col-xxl-6 login-wrapper py-5">
                    <div class="mx-auto login-w-limit">
                        <div class="logo-wrapper text-center mb-2">
                            <img src="../../../../assets/img/bau-logo-for-light.svg" height="35" />
                        </div>
                        <h4 class="text-center mb-5" style="min-height: 50px;">
                            {{ $t('guest_student_application_system') }}<br>{{ $t('password_reminder') }}
                        </h4>
                        <div class="fadeIn">
                            <ValidationObserver ref="form">
                                <div class="mx-auto">
                                    <ValidationProvider name="national_id" :rules="!form.passport_number ? 'required|digits:11' : ''" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('tc_no')">
                                            <b-form-input
                                                v-model="form.national_id"
                                                v-mask="'###########'"
                                                :disabled="!!form.passport_number"
                                                :state="errors[0] ? false : (valid ? true : null)" />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                    <ValidationProvider name="passport_number" :rules="!form.national_id ? 'required|max:255' : ''" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('passport_number')">
                                            <b-form-input
                                                v-model="form.passport_number"
                                                :disabled="!!form.national_id"
                                                :state="errors[0] ? false : (valid ? true : null)" />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                    <ValidationProvider name="birthdate" rules="required" v-slot="{ errors }">
                                        <b-form-group :label="$t('birthdate')">
                                            <select-date v-model="form.birthdate" :state="errors[0] ? false : null" />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                        </b-form-group>
                                    </ValidationProvider>
                                    <div class="d-flex justify-content-center my-4">
                                        <ProcessingButton
                                            block
                                            variant="primary"
                                            :label="$t('send')"
                                            :processing="loading"
                                            @click="sendReminder" />
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <b-button variant="link" class="text-secondary" @click="$router.push('/visitor-student/application/login')">
                                            {{ $t('login') }}
                                        </b-button>
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </GuestStudentLayout>
</template>

<script>
import GuestStudentLayout from "@/modules/visitorStudentApplication/student/layouts/GuestStudentLayout.vue";
import VisitorStudentApplicationServices from "@/services/VisitorStudentApplicationServices";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";

export default {
    name: "VisitorStudentForgotPassword",
    components: {
        GuestStudentLayout,
        ProcessingButton,
    },
    metaInfo() {
        return {
            title: this.$t('guest_student_application_system') + ' ' + this.$t('password_reminder'),
        };
    },
    data() {
        return {
            form: {
                national_id: null,
                passport_number: null,
                birthdate: null,
            },
            loading: false,
        }
    },
    methods: {
        async sendReminder() {
            const isValid = await this.$refs.form.validate();
            if (!isValid) return;

            try {
                this.loading = true;
                const data = { birthdate: this.form.birthdate }
                if (this.form.national_id) {
                    data.national_id = this.form.national_id
                } else {
                    data.passport_number = this.form.passport_number
                }

                await VisitorStudentApplicationServices.pinReminder(data)
                this.$toast.success(this.$t('password_send_success'))
                this.$router.push('/visitor-student/application/login')
            } catch (e) {
                this.showErrors(e, this.$refs.form)
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
